import React from 'react';
import { Button, Tooltip } from './base';
import { RollbackOutlined, EditOutlined } from '@ant-design/icons';

const EditButton = ({ editable, onEdit, onCancel, cancelText, editText, showAcceptRejectAll, acceptRejectAllText, onAcceptRejectAll, showLatestEBookingText, onShowLatestEbooking, disabled, tooltipText, showLatestEBookingStyle }) => (
    editable ?
        <>
            <Button icon={<RollbackOutlined />} onClick={onCancel} disabled={disabled}>{cancelText}</Button>
            {
                showAcceptRejectAll ?
                    <div>
                        <Button type="primary" icon={<EditOutlined />} onClick={onAcceptRejectAll} disabled={disabled}>
                            {acceptRejectAllText}
                        </Button>
                        <Tooltip title={tooltipText}>
                            <Button type="primary" style={Object.assign({}, { marginLeft: '1em' }, showLatestEBookingStyle || {})} onClick={onShowLatestEbooking} disabled={disabled}>
                                {showLatestEBookingText}
                            </Button>
                        </Tooltip>
                    </div>
                    :
                    ''
            }
        </>
        :
        <Button type="primary" icon={<EditOutlined />} onClick={onEdit} disabled={disabled}>{editText}</Button>
);

EditButton.defaultProps = {
    editable: false,
    cancelText: 'Cancel',
    editText: 'Edit',
    disabled: false
};

export default EditButton;
